export default "/images/1c22404b10b43c6edc51fe21f42f5234.avif";